"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _context = require("../../services/auth/context");
var _ = _interopRequireDefault(require("."));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Renderer = props => {
  var _props$isSimplifiedLo;
  const {
    modal,
    onCloseModal,
    onSetAuth
  } = (0, _context.useAuth)();
  if (modal === null) {
    return null;
  }
  const onGetSimpleToken = props.onGetSimpleToken ? props.onGetSimpleToken : onSetAuth;
  // These props can be set globally and overridden by ".onOpenModal()" call in specific cases
  const initialScreen = modal.initialScreen != null ? modal.initialScreen : props.initialScreen;
  const type = modal.type != null ? modal.type : props.type;
  const origin = modal.origin != null ? modal.origin : props.origin;
  const onSignInFulfill = modal.onSignInFulfill != null ? modal.onSignInFulfill : props.onSignInFulfill;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.default, {
    ...props,
    initialScreen: initialScreen,
    initialEmail: modal.initialEmail,
    type: type || "mmb",
    origin: origin,
    onClose: onCloseModal,
    onSignInFulfill: onSignInFulfill,
    onContinueAsGuest: modal.onContinueAsGuest,
    onContinueToSignIn: modal.onContinueToSignIn,
    onGetSimpleToken: onGetSimpleToken,
    isSimplifiedLoginFlow: (_props$isSimplifiedLo = props.isSimplifiedLoginFlow) !== null && _props$isSimplifiedLo !== void 0 ? _props$isSimplifiedLo : false,
    hideCloseButton: modal.hideCloseButton,
    customTitle: modal.customTitle,
    customDescription: modal.customDescription
  });
};
var _default = exports.default = Renderer;